import React from 'react';
import Row from '@amzn/meridian/row';
import { LineState } from 'src/pages/settings/tabs/siteLayout/types';
import LineCard from './LineCard';
import AddLineButton from './AddLineButton';

export interface LineCardListProps {
  lines: LineState[];
  processPathIndex: number;
  onAddLine: () => void;
  onDeleteLine: (lineIndex: number) => void;
  onLineNameChange: (lineIndex: number, name: string) => void;
}

const LineCardList: React.FC<LineCardListProps> = ({
  lines,
  processPathIndex,
  onAddLine,
  onDeleteLine,
  onLineNameChange,
}) => {
  return (
    <Row wrap="down" spacing="400" widths="grid-3">
      {lines.map((line, index) => (
        <LineCard
          key={line.lineId}
          line={line}
          processPathIndex={processPathIndex}
          lineIndex={index}
          onDelete={onDeleteLine}
          onLineNameChange={onLineNameChange}
        />
      ))}
      <AddLineButton onAdd={onAddLine} />
    </Row>
  );
};

export default LineCardList;
